<template>
    <div class="overview">
        <div
            v-for="section in sections"
            :key="section.title"
            :data-qa="section.title"
        >
            <div class="subheader">
                {{ section.title }}
            </div>

            <div v-if="section.content" class="content" data-qa="content">
                {{ section.content }}
            </div>

            <div v-else class="placeholder">
                {{ section.placeholder }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailBroadcastStepOverview',

    props: {
        sections: {
            type: Array,
            default: () => ([]),
        },
    },
};
</script>

<style lang="scss" scoped>
.overview {
    font-size: $font-size-sm;
    line-height: $line-height-sm;
    display: flex;
    flex-direction: column;
    gap: $spacing-200;
}

.subheader {
    font-weight: $font-weight-bold;
    padding-bottom: $spacing-050;
}

.placeholder {
    font-style: italic;
    color: $color-text-subtle;
}

.content {
    word-wrap: anywhere;
}
</style>
